const GRAY9 = "#212529"
const GRAY8 = "#343a40"
const GRAY7 = "#495057"
const GRAY6 = "#868e96"
const GRAY5 = "#adb5bd"
const GRAY4 = "#ced4da"
const GRAY3 = "#dee2e6"
const GRAY2 = "#e9ecef"
const GRAY1 = "#f1f3f5"
const GRAY0 = "#f8f9fa"

export const light = {
  name: "light",
  colors: {
    bodyBackground: "#ffffff",
    text: GRAY9,
    secondaryText: GRAY7,
    tertiaryText: GRAY6,
    mutedText: GRAY5,
    hoveredLinkText: GRAY0,
    border: GRAY4,
    activatedBorder: GRAY6,
    background: GRAY1,
    icon: GRAY6,
    divider: GRAY2,
    headerBackground: "rgba(255, 255, 255, 0.85)",
    headerShadow: "rgba(0, 0, 0, 0.08)",
    inlineCodeBackground: GRAY2,
    inlineCodeBackgroundDarker: GRAY4,
    tagBackground: GRAY1,
    selectedTagBackground: GRAY7,
    hoveredTagBackground: GRAY3,
    hoveredSelectedTagBackground: GRAY8,
    nextPostButtonBackground: "rgba(0, 0, 0, 0.06)",
    hoveredNextPostButtonBackground: "rgba(0, 0, 0, 0.08)",
    seriesBackground: GRAY1,
    tagText: GRAY7,
    selectedTagText: GRAY0,
    spinner: GRAY7,
    scrollTrack: GRAY1,
    scrollHandle: GRAY4,
    blockQuoteBorder: GRAY4,
    blockQuoteBackground: GRAY1,
    textFieldBorder: GRAY4,
    textFieldActivatedBorder: GRAY5,
    tableBackground: GRAY1,
  },
}

export const dark = {
  name: "dark",
  colors: {
    bodyBackground: GRAY9,
    text: GRAY0,
    secondaryText: GRAY4,
    tertiaryText: GRAY5,
    mutedText: GRAY6,
    hoveredLinkText: GRAY9,
    border: GRAY5,
    activatedBorder: GRAY3,
    background: GRAY8,
    icon: GRAY5,
    divider: GRAY8,
    headerBackground: "rgba(33, 37, 41, 0.85)",
    headerShadow: "rgba(255, 255, 255, 0.08)",
    inlineCodeBackground: GRAY7,
    inlineCodeBackgroundDarker: GRAY8,
    tagBackground: GRAY8,
    selectedTagBackground: GRAY2,
    hoveredTagBackground: GRAY7,
    hoveredSelectedTagBackground: GRAY1,
    nextPostButtonBackground: "rgba(255, 255, 255, 0.05)",
    hoveredNextPostButtonBackground: "rgba(255, 255, 255, 0.08)",
    seriesBackground: GRAY8,
    tagText: GRAY2,
    selectedTagText: GRAY9,
    spinner: GRAY1,
    scrollTrack: GRAY8,
    scrollHandle: GRAY6,
    blockQuoteBorder: GRAY7,
    blockQuoteBackground: GRAY8,
    textFieldBorder: GRAY7,
    textFieldActivatedBorder: GRAY6,
    tableBackground: "#292e33",
  },
}
